import type { CosignatureDocumentType } from "@/core/types";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export type CosignDocumentVariables = {
  documentId: string;
  documentType: CosignatureDocumentType;
  patientId: string;
};

export async function cosignDocument({
  documentId,
  documentType,
  patientId,
}: CosignDocumentVariables): Promise<void> {
  return cosignatureRequestsTyped.cosign_document({
    body: { document_type: documentType, patient_id: patientId },
    urlParams: { documentId },
  });
}
